import React from "react";

export default function FooterLiquid({ onClick }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="section-liquid"
      style={{
        background:
          "linear-gradient(135deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%)",
        borderTop: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <div className="container-liquid">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "40px",
            marginBottom: "40px",
          }}
        >
          {/* Brand Section */}
          <div>
            <h3
              className="heading-liquid"
              style={{
                fontSize: "1.5rem",
                marginBottom: "16px",
              }}
            >
              Online Badho
            </h3>
            <p
              className="text-liquid"
              style={{
                marginBottom: "24px",
                lineHeight: "1.6",
              }}
            >
              Helping businesses grow online with professional web solutions and
              digital expertise.
            </p>
            <div
              style={{
                display: "flex",
                gap: "12px",
              }}
            >
              <button
                className="glass-button"
                style={{
                  width: "40px",
                  height: "40px",
                  padding: "8px",
                }}
              >
                📧
              </button>
              <button
                className="glass-button"
                style={{
                  width: "40px",
                  height: "40px",
                  padding: "8px",
                }}
              >
                📱
              </button>
              <button
                className="glass-button"
                style={{
                  width: "40px",
                  height: "40px",
                  padding: "8px",
                }}
              >
                🌐
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="heading-liquid"
              style={{
                fontSize: "1.2rem",
                marginBottom: "16px",
              }}
            >
              Quick Links
            </h4>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {[
                "Home",
                "Services",
                "Pricing",
                "Reviews",
                "FAQs",
                "Contact",
              ].map((link) => (
                <button
                  key={link}
                  onClick={() => onClick(link)}
                  className="text-liquid"
                  style={{
                    background: "none",
                    border: "none",
                    padding: "4px 0",
                    textAlign: "left",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "rgba(0, 122, 255, 0.9)";
                    e.target.style.transform = "translateX(8px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "var(--text-secondary-dark)";
                    e.target.style.transform = "translateX(0)";
                  }}
                >
                  {link}
                </button>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4
              className="heading-liquid"
              style={{
                fontSize: "1.2rem",
                marginBottom: "16px",
              }}
            >
              Services
            </h4>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {[
                "Website Design",
                "Landing Pages",
                "E-commerce",
                "SEO Optimization",
                "Domain & Hosting",
                "Technical Support",
              ].map((service) => (
                <span
                  key={service}
                  className="text-liquid"
                  style={{
                    padding: "4px 0",
                    fontSize: "0.9rem",
                  }}
                >
                  {service}
                </span>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="heading-liquid"
              style={{
                fontSize: "1.2rem",
                marginBottom: "16px",
              }}
            >
              Contact Info
            </h4>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div
                className="glass-secondary"
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                }}
              >
                <div style={{ marginBottom: "4px" }}>📍 Mumbai Office</div>
                <div className="text-liquid" style={{ fontSize: "0.8rem" }}>
                  D-2, Bhadran Nagar, Malad West
                </div>
              </div>
              <div
                className="glass-secondary"
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                }}
              >
                <div style={{ marginBottom: "4px" }}>📞 Phone</div>
                <div className="text-liquid" style={{ fontSize: "0.8rem" }}>
                  +91 (986) 777-9087
                </div>
              </div>
              <div
                className="glass-secondary"
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                }}
              >
                <div style={{ marginBottom: "4px" }}>📧 Email</div>
                <div className="text-liquid" style={{ fontSize: "0.8rem" }}>
                  onlinebadho.ind@gmail.com
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div
          style={{
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            paddingTop: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <p
            className="text-liquid"
            style={{
              fontSize: "0.9rem",
              margin: 0,
            }}
          >
            © {currentYear} Online Badho. All rights reserved.
          </p>
          <div
            style={{
              display: "flex",
              gap: "24px",
              fontSize: "0.9rem",
            }}
          >
            <span className="text-liquid" style={{ cursor: "pointer" }}>
              Privacy Policy
            </span>
            <span className="text-liquid" style={{ cursor: "pointer" }}>
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
